import { FormGroup, Select } from '@ksyos/design-system';
import type { IAdminProcessesListSearchState } from '@frontend/components/interfaces/adminProcessesList';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { getSelectedLanguage } from '../../../../../translate';
import {
    consultationAdminLabels,
    contactAdminLabels,
    counselingAdminLabels,
    examinationAdminLabels,
    invitationAdminLabels,
    referralAdminLabels,
} from './adminProcessesStatusLabelsLists';

interface IAdminProcessesListFilterStatusProps {
    searchState: IAdminProcessesListSearchState;
    services: {
        id: string;
        serviceType: ServiceType;
    }[];
    setSearchState: (partialSearchState: Partial<IAdminProcessesListSearchState>) => void;
}

export function AdminProcessesListFilterStatus(props: IAdminProcessesListFilterStatusProps) {
    const language = getSelectedLanguage();
    let filterOnServiceType = props.searchState.serviceType;
    if (!filterOnServiceType && props.searchState.serviceId) {
        const selectedService = props.services.find((service) => service.id === props.searchState.serviceId);
        if (selectedService) {
            filterOnServiceType = selectedService.serviceType;
        }
    }

    return (
        <FormGroup
            label="Status"
            layout="vertical"
        >
            <Select
                isClearable={true}
                isDisabled={getAdminLabelOptions(filterOnServiceType).length === 0}
                onChange={(item) =>
                    props.setSearchState({ serviceType: filterOnServiceType, statusLabel: item ? item.value : null })
                }
                options={getAdminLabelOptions(filterOnServiceType)}
                placeholder={language.request.status + '...'}
                value={
                    props.searchState.statusLabel && {
                        label: language.StatusLabelEnum[props.searchState.statusLabel],
                        value: props.searchState.statusLabel,
                    }
                }
            />
        </FormGroup>
    );

    function getAdminLabelOptions(serviceType: ServiceType | null) {
        if (!serviceType) {
            return [];
        }

        const adminLabels = getAdminLabels(serviceType);
        const options = [];
        for (const label of adminLabels) {
            options.push({
                label: language.StatusLabelEnum[label],
                value: label,
            });
        }

        return options;
    }

    function getAdminLabels(serviceType: ServiceType) {
        switch (serviceType) {
            case ServiceType.examination:
                return examinationAdminLabels;
            case ServiceType.consultation:
                return consultationAdminLabels;
            case ServiceType.referral:
            case ServiceType.referralSmall:
                return referralAdminLabels;
            case ServiceType.contact:
                return contactAdminLabels;
            case ServiceType.counseling:
                return counselingAdminLabels;
            case ServiceType.invitation:
                return invitationAdminLabels;
            default:
                return [];
        }
    }
}
